function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHistory = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.816,7.663C1.816,4.136 4.678,1.274 8.206,1.274L29.505,1.274C30.683,1.274 31.635,2.226 31.635,3.404L31.635,24.703C31.635,25.881 30.683,26.833 29.505,26.833L29.505,31.092C30.683,31.092 31.635,32.044 31.635,33.222C31.635,34.4 30.683,35.352 29.505,35.352L8.206,35.352C4.678,35.352 1.816,32.49 1.816,28.962L1.816,7.663ZM6.076,28.962C6.076,30.141 7.028,31.092 8.206,31.092L25.245,31.092L25.245,26.833L8.206,26.833C7.028,26.833 6.076,27.784 6.076,28.962ZM18.283,20.163C18.037,20.41 17.87,20.443 17.791,20.443C17.711,20.443 17.544,20.41 17.298,20.163C17.045,19.917 16.766,19.498 16.513,18.905C16.1,17.94 15.794,16.622 15.701,15.118L19.894,15.118C19.794,16.622 19.494,17.94 19.082,18.905C18.829,19.498 18.549,19.917 18.296,20.163L18.283,20.163ZM21.125,19.504C21.611,18.286 21.924,16.769 22.017,15.118L24.087,15.118C23.774,16.975 22.663,18.559 21.125,19.504ZM21.125,8.602C22.669,9.547 23.781,11.131 24.087,12.988L22.017,12.988C21.924,11.344 21.611,9.827 21.125,8.602ZM26.31,14.053C26.31,9.347 22.496,5.534 17.791,5.534C13.085,5.534 9.271,9.347 9.271,14.053C9.271,18.759 13.085,22.573 17.791,22.573C22.496,22.573 26.31,18.759 26.31,14.053ZM11.487,15.118L13.557,15.118C13.651,16.762 13.963,18.28 14.449,19.504C12.905,18.559 11.794,16.975 11.487,15.118ZM13.557,12.988L11.487,12.988C11.8,11.131 12.912,9.547 14.449,8.602C13.963,9.82 13.651,11.338 13.557,12.988ZM17.291,7.943C17.538,7.697 17.704,7.663 17.784,7.663C17.864,7.663 18.03,7.697 18.276,7.943C18.529,8.189 18.809,8.609 19.062,9.201C19.475,10.166 19.781,11.484 19.874,12.988L15.681,12.988C15.78,11.484 16.08,10.166 16.493,9.201C16.746,8.609 17.025,8.189 17.278,7.943L17.291,7.943Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHistory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/history.04e746d6e07c94354100f3ed0941b9ef.svg";